{
  "development": {
    "label": "Orbitta Demo Analytics (DEV / HML / HEXT)",
    "ga4PropertyId": "",
    "ga4AccountId": "",
    "ga4WebStreamId": "",
    "ga4AndroidStreamId": "",
    "ga4IosStreamId": "",
    "apiKey": "AIzaSyDRl8kctilpG6hiBWarJUkeTw0pWvxq5IQ",
    "authDomain": "orbitta-demo-analytics.firebaseapp.com",
    "databaseURL": "",
    "projectId": "orbitta-demo-analytics",
    "storageBucket": "orbitta-demo-analytics.firebasestorage.app",
    "messagingSenderId": "428811061543",
    "appId": "1:428811061543:web:6d4aa77028ecc13da94102",
    "measurementId": "G-F8XFEYSSXM"
  },
  "production": {
    "label": "Orbitta (PDV) — SOROCABA REFRESCOS",
    "ga4PropertyId": "546470587",
    "ga4AccountId": "400453905",
    "ga4WebStreamId": "15296744046",
    "ga4WebStreamUrl": "https://orbitta.sorocabarefrescos.com.br",
    "ga4AndroidStreamId": "15296794019",
    "ga4IosStreamId": "15296794640",
    "gtmContainerId": "GT-NFB5DWD7",
    "apiKey": "AIzaSyAeyDWDL3zkXWL6kN0y2hYZ7s6veq-K56o",
    "authDomain": "carteira-3f277.firebaseapp.com",
    "databaseURL": "https://carteira-3f277.firebaseio.com",
    "projectId": "carteira-3f277",
    "storageBucket": "carteira-3f277.appspot.com",
    "messagingSenderId": "688662940834",
    "appId": "",
    "measurementId": "G-QF7MXB7T24"
  }
}
